import { format, isValid } from 'date-fns';
import { apiStatic } from 'AurionCR/components';
import { API_MEDIA_UPLOADS } from 'services/media-uploads';
import { validURL } from 'utils/validation';

export const dateHelper = (date: any, dateFormat = 'dd/MM/yyyy') => {
  return date ? (isValid(new Date(date)) ? format(new Date(date), dateFormat) : '') : '';
};

export const linkHelper = (link: any, title: string) => {
  return link ? `[<a href='${link}'>${title}</a>]` : '';
};

export const getHtml = async (path: string): Promise<string> => {
  if (path && validURL(path)) {
    try {
      const { data } = await apiStatic.post(API_MEDIA_UPLOADS.GET_HTML_FROM_CLOUD, {
        fileName: path,
      });
      return data || '';
    } catch (error) {
      console.error('Error loading HTML:', error);
      return '';
    }
  }
  return '';
};

export const psdStyle = `
<style>
  * {
    font: 14px Arial, Helvetica, sans-serif;
  }
  table {
    border-spacing: 0;
    border-collapse: collapse;
    margin: 0 0 15px;
  }
  .full-width {
    width: 100%;
  }
  h1.pageTitle {
    font-size: 20px;
    background: #0028a0;
    color: #fff;
    padding: 5px 10px;
    margin: 0 0 15px;
  }
  h2 {
    color: #0028a0;
    font-size: 22px;
    padding: 0 0 15px;
    margin: 0;
  }
  h3 {
    color: #0028a0;
    font-size: 18px;
    padding: 0 0 15px;
    margin: 0;
  }
  h4 {
    color: #0028a0;
    font-size: 14px;
    padding: 0 0 10px;
    margin: 0;
  }
  p {
    padding: 0 0 10px;
  }
  .tablePreview td,
  .tablePreview th {
    padding: 7px 10px;
  }
  .tablePreview th {
    white-space: nowrap;
  }
  .tablePreview tbody th {
    text-align: right;
    vertical-align: baseline;
  }
  .tableStandard {
    border: 1px solid #ccc;
    border-bottom: none;
    border-left: none;
  }
  .tableStandard th {
    font-weight: 700;
  }
  .tableStandard td, .tableStandard th {
    border-bottom: 1px solid #ccc;
    border-left: 1px solid #ccc;
    padding: 7px 10px;
  }
  .tableTdCenter td,
  .tableTdCenter th {
    text-align: center;
  }
  .html p,
  .html h1,
  .html h2,
  .html h3,
  .html h4,
  .html h5,
  .html h6 {
    padding: 0 0 10px;
    margin: 0;
  }
  div.html {
    padding: 0 0 15px;
  }
</style>
`;

